
<p-dialog #addUserDialog [contentStyle]="{'max-height':'85vh'}" [focusOnShow]="false" width="800" minHeight="600"
  [closable]="true" [blockScroll]="true" [modal]="true" [draggable]="false" [baseZIndex]="500"
  header="Cancel Short Code Lease" [(visible)]="display" (onHide)="cancel()">
 
    <div class="mb-2 ms-3 me-5" *ngIf="!isSuccess">
      <div>
        <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <p>{{informationMessage}}
           </p>
        </div>
        <div class="col-12 mt-2">
          <p>{{confirmationMessage}} </p> 
        </div>
        <div class="col-12 mt-2">
         <p>
          Please click the OK button to continue with the cancellation. For assistance, please
          contact customer support at support&#64;iconectiv.com.
         </p> 
        </div>
    </div>
    
    </div>



  <div class="row mb-2" *ngIf="isSuccess">
    <div class="col-12">
      <p>{{successMessage}}
       </p>
    </div>
    
</div>
  <p-footer>
    <div class="d-flex justify-content-end me-2">
      <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="cancelLeaseShortCode()">OK</button>
      <button i18n id="screject" class="btn btn-secondary" *ngIf="!isSuccess" type="button" (click)="closeDialog()">Cancel</button>
    </div>
  </p-footer>
</p-dialog>

<!-- <app-cancel-shortcode-lease-dialog [style]="{width: '40vw'}"  [errorMessage]="successMessage"
    >
</app-cancel-shortcode-lease-dialog> -->